<template>
    <div>
        <h5>Providers offer their own unique plans: {{ allowProviderPlans | yesNo }}</h5>
        
        <h5>Plans in Offering</h5>
        <table border="0" class="tableDemo bordered table table-bordered small">
            <thead class="ajaxTitle">
                <tr class="ajaxTitle">
                    <th width="50%">Plan Name</th>
                    <th width="50%">Prices</th>
                </tr>
            </thead>
            <tbody id="poolPlans">
                <tr v-for="p in plans" :key="p.planId">
                    <td class="name">
                        <span>
                            {{ p.planName }}
                        </span>
                        <upcoming-plan-changes :plan-id="p.planId">
                            <template slot-scope="contProps">
                                <span class="label label-warning" style="cursor: pointer"
                                    v-if="contProps.hasPendingChange">
                                    <span>
                                        <i class="fa fa-info-circle"></i> Changing
                                    </span>
                                </span>
                            </template>
                        </upcoming-plan-changes>
                    </td>
                    <td class="name">
                        <template v-for="tier in p.priceTiers">
                            {{ tier.price | currency }} Ages {{ tier.minAge }} - {{ tier.maxAge }} ({{ tier.relationship }})
                        </template>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import {api} from "../../../../global/framework/api.js";
    import {common} from "../../../../global/common.js";
    import UpcomingPlanChanges from "../../../../components/shared/physicianProfileAndPlans/UpcomingPlanChanges.vue";

    export default {
        name: "ViewPlan",
        components: {UpcomingPlanChanges},
        props: {
            consultantId: {type: [Number], required: true},
            planPoolId: {type: [Number], required: true},
        },
        data() {
            return {
                plans: [],
                allowProviderPlans: false,
            };
        },
        computed: {
            
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                // console.log("ViewPlans showModal consultantId, planPoolId:", this.consultantId, this.planPoolId);
                let poolPlans = await api.getDataWithTwoIds('MediatorPlan', this.consultantId, 'GetPlansInPool', this.planPoolId);
                this.plans = (poolPlans.mediatorPoolPlans || []).concat(poolPlans.networkPoolPlans || []);
                this.allowProviderPlans = poolPlans.allowProviderPlans || false;
                
                for (let plan of this.plans){
                    for (let tier of plan.priceTiers){
                        tier.relationship = common.RELATIONSHIP_TYPE[tier.consumerRelationshipId];
                    }                    
                }
            },
        },
        watch: {
            planPoolId(newValue) {
                this.init();
            }
        }
    }
</script>

<style scoped>

</style>